<mat-card>
  <mat-card-content>

    <div class="ehr-section-header">
      <h2>Electronic Health Record and Practice Management Details</h2>
      <button mat-raised-button color="primary" class="add-ehr-btn" (click)="onAddClicked()">
        ADD
      </button>
    </div>

    <ag-grid-angular
      [rowData]="systemRowData"
      [columnDefs]="colDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [theme]="theme"
      [suppressCellFocus]="true"
      (cellClicked)="onCellClicked($event)"
      class="ehr-grid"
    />

    <mat-divider class="divider"></mat-divider>

    <div [formGroup]="emrForm" [connectForm]="form$ | async">
      <mat-radio-group formControlName="isMemberOfACO">
        <h2>Is your organization part of ACO?</h2>
        <mat-radio-button value="1"><b>Yes</b></mat-radio-button>
        <mat-radio-button value="0"><b>No</b></mat-radio-button>
      </mat-radio-group>
    </div>

  </mat-card-content>
</mat-card>
